import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { style } from '../utils/style.js';
import { defaultBlockDecorator } from './defaultBlockDecorator.js';
const DEFAULT_ANCESTORS = [];
const defaultStyle = 'col-span-12';
export function renderBlock(block, options, { className, ...extraProps } = {}) {
    const { key, blockDecorator = defaultBlockDecorator, blocksRegistry = {}, ancestors = DEFAULT_ANCESTORS, } = options;
    const { type } = block;
    if (!(type && type in blocksRegistry)) {
        console.warn(`No block with "${type}" is registered`);
    }
    const BlockComponent = type && blocksRegistry[type];
    return blockDecorator({
        blockClassName: style(block.style?.length ? block.style : defaultStyle, className),
        block,
        ancestors,
        // Adjusted by decorator block and blockClassName
        render: ({ block: adjustedBlock, blockClassName: adjustedBlockClassName }) => {
            const { content } = adjustedBlock;
            return BlockComponent ? (_jsx(BlockComponent, { className: adjustedBlockClassName, block: block, options: options, ...content, ...extraProps }, key)) : null;
        },
    }, key);
}
//# sourceMappingURL=renderBlock.js.map